import styled from 'styled-components';
import StatusTooltip from './component';

export default styled(StatusTooltip)`
  box-shadow: -0.5px 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: white;

  &.show {
    opacity: 1;
    padding: 0;
  }

  .content {
    display: flex;
    width: 72px;
    height: 36px;

    &__icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      width: 36px;

      &:hover {
        background-color: var(--primary100);
        cursor: pointer;
      }
    }
  }
`;
